import React from 'react';
import Icon from 'components/AppIcon';

const DashboardMetrics = ({ metrics }) => {
  const metricCards = [
    {
      id: 'applications',
      label: 'Jobs Submitted',
      value: metrics.applicationsSubmitted,
      icon: 'FileText',
      color: 'primary',
      trend: '+3 this week',
      trendUp: true
    },
    {
      id: 'interviews',
      label: 'Interviews',
      value: metrics.interviewsScheduled,
      icon: 'Calendar',
      color: 'success',
      trend: '+1 this week',
      trendUp: true
    },
    {
      id: 'saved',
      label: 'Saved Jobs',
      value: metrics.savedJobs,
      icon: 'Bookmark',
      color: 'warning',
      trend: 'Updated today',
      trendUp: null
    },
    {
      id: 'matches',
      label: 'New Matches',
      value: metrics.newMatches,
      icon: 'Zap',
      color: 'secondary',
      trend: 'Based on your profile',
      trendUp: null
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {metricCards.map((card) => (
        <div
          key={card.id}
          className="bg-card text-card-foreground rounded-2xl p-6 shadow-lg hover:shadow-md transition-all duration-300 ease-in-out"
        >
          <div className="flex justify-between items-start">
            <div>
              <p className="text-muted-foreground text-sm font-medium">{card.label}</p>
              <h3 className="text-5xl font-bold mt-2 tracking-tight text-card-foreground">{card.value}</h3>
              <div className="flex items-center mt-2 text-xs">
                {card.trendUp !== null && (
                  <Icon
                    name={card.trendUp ? "TrendingUp" : "TrendingDown"}
                    size={14}
                    className={card.trendUp ? "text-success mr-1" : "text-error mr-1"}
                  />
                )}
                <span className={card.trendUp === null ? "text-muted-foreground" : (card.trendUp ? "text-success" : "text-error")}>
                  {card.trend}
                </span>
              </div>
            </div>
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center bg-${card.color}-50 bg-opacity-50`}>
              <Icon
                name={card.icon}
                size={20}
                className={`text-${card.color}-600`}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardMetrics;